import { render, staticRenderFns } from "./Waves.vue?vue&type=template&id=f0d909ae&scoped=true&"
var script = {}
import style0 from "./Waves.vue?vue&type=style&index=0&id=f0d909ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d909ae",
  null
  
)

export default component.exports